import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AiFillDollarCircle } from "react-icons/ai";
import OperationPaymentsForm from "../../from";
import { IoIosAddCircleOutline } from "react-icons/io";
import { setDialog } from "../../../../../../../../app/slices/paymentsSlice";

const OperationPaymentHeader = () => {
  const _Payment = useSelector((state) => state.payment.payment);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            حركات الدفع
          </Typography>
        }
        avatar={<AiFillDollarCircle size={20} />}
        action={
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<IoIosAddCircleOutline />}
            onClick={() => dispatch(setDialog())}
          >
            إضافة
          </Button>
        }
      />
      {_Payment.dialog ? <OperationPaymentsForm /> : null}
    </Card>
  );
};

export default OperationPaymentHeader;
